'use client'

import { createContext, useContext, useTransition, type ReactNode } from 'react'
import { useLocale, useTranslations } from 'next-intl'
import { getDefaultDirection } from '@hamishon/i18n'
import { BrandLoading } from './BrandLoading'
import styles from './navigation.module.css'

const NavigationContext = createContext<(navigate: () => void) => void>((navigate) => navigate())

export const useNavigationTransition = () => useContext(NavigationContext)

export function NavigationFeedbackProvider({ children }: { children: ReactNode }) {
  const [pending, startNavigation] = useTransition()
  const t = useTranslations('common.state')
  const locale = useLocale()

  return (
    <NavigationContext.Provider value={startNavigation}>
      {children}
      {pending && (
        <div className={styles.feedback} data-navigation-pending="">
          <div className={styles.topTrack} aria-hidden="true"><span /></div>
          <BrandLoading
            compact
            lang={getDefaultDirection(locale) === 'rtl' ? 'fa' : 'en'}
            label={t('loading')}
          />
        </div>
      )}
    </NavigationContext.Provider>
  )
}
